var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://zbhk.lnyun.com.cn/www/huanren/images/202401/1746759697022550017.jpg"}})])
}]

export { render, staticRenderFns }